<template>
  <div
    class="avatar"
    :class="kind"
    :style="{
      width: size + 'px',
      height: size + 'px',
      fontSize: fontSize + 'px',
    }"
  >
    <template v-if="kind === 'agent'">e</template>
    <template v-else>{{ initials }}</template>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{ kind: "agent" | "user"; initials?: string; size?: number }>(),
  { size: 28, initials: "?" }
);

const fontSize = computed(() =>
  props.kind === "agent" ? props.size * 0.46 : props.size * 0.4
);
</script>

<style scoped>
.avatar {
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: "Inter", sans-serif;
  flex-shrink: 0;
  letter-spacing: -0.01em;
}
.avatar.agent {
  background: var(--ink);
  color: #fff;
  font-weight: 700;
  letter-spacing: -0.03em;
}
.avatar.user {
  background: var(--border);
  color: var(--ink);
  font-weight: 600;
}
</style>
